import React from 'react';
import { useNavigate } from 'react-router-dom';

const Error404 = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
      {/* <Header title="Error404" /> */}
      <main className="strict-width">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 py-5">
                <div className="text-center mb-4">
                  <h1 className="display-1 fw-bold text-white mb-3">Oops!</h1>
                  <p className="text-white fs-5 mb-1">You got lost!</p>
                  <p className="text-white-50" style={{ fontSize: '0.85rem' }}>
                    Let's get you back on track
                  </p>
                </div>
                <div className="error-image-wrapper mb-6">
                  <img
                    src="assets/images/app-image/cell-phone-403.svg"
                    alt="404 Error"
                    className="img-fluid"
                    style={{ maxWidth: '150px', width: '100%' }}
                  />
                </div>
                <button
                  onClick={handleGoHome}
                  className="btn btn-sm btn-light rounded-pill px-5 py-3 fw-bold"
                  style={{ marginTop: '2.5rem' }}
                >
                  Go Back Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Error404;
